/*
 * File: AntCardTitle.tsx
 * Project: beaker
 * -----
 * Last Modified: 25 Apr 2022 11:50:55 am
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { Typography } from 'antd';
import { TitleProps } from 'antd/lib/typography/Title';
import { InlineStylesModel } from 'models/InlineStylesModel';
import React, { FC } from 'react';

const styles: InlineStylesModel = {
  title: {
    margin: 0,
    fontWeight: 'normal',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  }
};

interface ExtendedTitleProps extends TitleProps {
  text: string;
}

export const AntCardTitle: FC<ExtendedTitleProps> = (props: ExtendedTitleProps) => {
  return (
    <Typography.Title level={5} style={styles.title}>
      {props.text}
    </Typography.Title>
  );
};
